import $ from "jquery";

$('#js-ctaClose').on('click', function() {
  $('#js-cta').fadeOut();
});
